module.exports = __webpack_public_path__ + "img/sheep.ed00e4ff.jpg";